import React, { useMemo } from 'react';
import { orderAPI } from '../../api/api';
import { useApi } from '../../api/useApi';
import useIsMobile from '../../hooks/useIsMobile';

const formatReviewDate = (value) => {
  if (!value) return '';
  return new Date(value).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

const getInitials = (name) =>
  String(name || 'SC')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('') || 'SC';

export default function Testimonials() {
  const isMobile = useIsMobile();
  const { data, loading } = useApi(orderAPI.getPublicTestimonials);

  const testimonials = useMemo(() => (Array.isArray(data) ? data : []), [data]);

  return (
    <section id="testimonials" style={{ padding: isMobile ? '56px 16px' : '80px 24px', backgroundColor: '#f8fdf9' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '56px' }}>
          <span
            style={{
              background: '#d8f3dc',
              color: '#2d6a4f',
              padding: '6px 20px',
              borderRadius: '999px',
              fontSize: '13px',
              fontWeight: '600',
            }}
          >
            Customer Reviews
          </span>
          <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: '700', color: '#1a1a2e', marginTop: '16px' }}>
            What Our Customers Say
          </h2>
          <p style={{ color: '#6b7280', marginTop: '12px', fontSize: '1.1rem' }}>
            Real feedback collected from delivered Sedyam orders
          </p>
        </div>

        {loading ? (
          <div
            style={{
              background: 'white',
              borderRadius: '24px',
              padding: '32px',
              textAlign: 'center',
              color: '#64748b',
              boxShadow: '0 4px 20px rgba(0,0,0,0.07)',
            }}
          >
            Loading fresh customer reviews...
          </div>
        ) : testimonials.length === 0 ? (
          <div
            style={{
              background: 'white',
              borderRadius: '24px',
              padding: '32px',
              textAlign: 'center',
              color: '#64748b',
              boxShadow: '0 4px 20px rgba(0,0,0,0.07)',
            }}
          >
            Reviews will appear here after customers complete deliveries and share feedback.
          </div>
        ) : (
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: `repeat(auto-fill, minmax(${isMobile ? 230 : 300}px, 1fr))`,
              gap: isMobile ? '16px' : '28px',
            }}
          >
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.id}
                style={{
                  background: 'white',
                  borderRadius: '20px',
                  padding: isMobile ? '18px' : '28px',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.07)',
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    top: '16px',
                    right: '20px',
                    fontSize: isMobile ? '54px' : '80px',
                    color: '#d8f3dc',
                    fontFamily: 'Georgia',
                    lineHeight: 1,
                    userSelect: 'none',
                  }}
                >
                  "
                </div>

                <div style={{ marginBottom: '16px' }}>
                  {[...Array(Number(testimonial.rating || 0))].map((_, index) => (
                    <span key={`${testimonial.id}-${index}`} style={{ color: '#f59e0b', fontSize: '18px' }}>★</span>
                  ))}
                </div>

                <p
                  style={{
                    color: '#374151',
                    fontSize: '1rem',
                    lineHeight: '1.7',
                    marginBottom: '18px',
                    position: 'relative',
                    zIndex: 1,
                  }}
                >
                  "{testimonial.text}"
                </p>

                {testimonial.productName ? (
                  <p style={{ color: '#166534', fontSize: '12px', fontWeight: 700, marginBottom: '18px' }}>
                    Ordered: {testimonial.productName}
                  </p>
                ) : null}

                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div
                    style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      background: '#d8f3dc',
                      color: '#166534',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 800,
                      border: '2px solid #52b788',
                    }}
                  >
                    {getInitials(testimonial.name)}
                  </div>
                  <div>
                    <p style={{ fontWeight: '700', color: '#1a1a2e', fontSize: '15px' }}>{testimonial.name}</p>
                    <p style={{ color: '#6b7280', fontSize: '13px' }}>
                      {testimonial.city}
                      {testimonial.createdAt ? ` • ${formatReviewDate(testimonial.createdAt)}` : ''}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
